<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions"
    aria-label="Profile"
    >
    <span class="relative">
        <span class="w-8 h-8 flex flex-shrink-0 rounded-full" *ngIf="hasValidProfilePicture(user?.profile_picture)">
            <img class="w-8 h-8 rounded-full" [src]="user?.profile_picture" alt="">
        </span>
        <div *ngIf="!hasValidProfilePicture(user?.profile_picture)"
        class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 rounded-full text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-8 w-8 flex-shrink-0 sm:h-7 sm:w-7 lg:h-10 lg:w-10">
        {{user?.first_name[0]}}
        </div>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{'text.signed_in_as' | translate}}</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <a mat-menu-item (click)="showProfileDetails()">
        <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
        <span>{{'text.profile' | translate}}</span>
    </a>
    <a mat-menu-item (click)="redirectToSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>{{'text.settings' | translate}}</span>
    </a>
    <a *ngIf="user?.role?.role_key === 'ADMIN'" mat-menu-item (click)="redirectToAppStore()">
        <mat-icon [svgIcon]="'heroicons_outline:layer'"></mat-icon>
        <span>{{'text.app_store' | translate}}</span>
    </a>
    <a mat-menu-item href="https://care.zuper.co/portal/en/kb/support-article" target="_blank" rel="noopener">
        <mat-icon [svgIcon]="'heroicons_outline:exclamation-circle'"></mat-icon>
        <span>{{'text.help' | translate}}</span>
    </a>
    <a mat-menu-item id="whats-new-btn" rel="noopener">
        <mat-icon [svgIcon]="'heroicons_outline:fire'"></mat-icon>
        <span>{{'text.whats_new' | translate}}</span>
    </a>
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>{{'status.text' | translate}}</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>{{'logout.dialog.title' | translate}}</span>
    </button>
</mat-menu>

<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>{{'text.online' | translate}}</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>{{'ext.away' | translate}}</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>{{'text.busy' | translate}}</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>{{'text.invisible' | translate}}</span>
    </button>
</mat-menu>
